import { initContract } from '@ts-rest/core';
const c = initContract();
export const databases = ['pubmed', 'openalex'];
export const literatureReviewContract = c.router({
    listLiteratureReviews: {
        method: 'GET',
        path: '/literature-reviews',
        responses: {
            200: c.type(),
        },
    },
    getLiteratureReview: {
        method: 'GET',
        path: '/literature-reviews/:id',
        responses: {
            200: c.type(),
        },
    },
    searchPapers: {
        method: 'POST',
        path: '/literature-reviews/search',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createLiteratureReview: {
        method: 'POST',
        path: '/literature-reviews',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateLiteratureReview: {
        method: 'PUT',
        path: '/literature-reviews/:id',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createAndExecuteLiteratureReviewSearches: {
        method: 'POST',
        path: '/literature-reviews/:id/searches',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    upsertLiteratureReviewSearches: {
        method: 'POST',
        path: '/literature-reviews/:id/upsert-searches',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createAbstractScreening: {
        method: 'POST',
        path: '/literature-reviews/:id/abstract-screening',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    executeAbstractScreening: {
        method: 'POST',
        path: '/literature-reviews/:id/abstract-screening/execute',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getAbstractScreening: {
        method: 'GET',
        path: '/literature-reviews/:id/abstract-screening',
        responses: {
            200: c.type(),
        },
    },
    getAbstractScreeningResults: {
        method: 'GET',
        path: '/literature-reviews/:id/abstract-screening/results',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getSearchResults: {
        method: 'GET',
        path: '/literature-reviews/:id/search-results',
        responses: {
            200: c.type(),
        },
    },
    getLiteratureSearches: {
        method: 'GET',
        path: '/literature-reviews/:id/searches',
        responses: {
            200: c.type(),
        },
    },
    exportLiteratureReview: {
        method: 'POST',
        path: '/literature-reviews/:id/export',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updatePaperScreeningValidationStatus: {
        method: 'PATCH',
        path: '/literature-reviews/paper-screenings/:paperScreeningId/validation-status',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    bulkValidatePaperScreenings: {
        method: 'POST',
        path: '/literature-reviews/paper-screenings/bulk-validate',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updatePaperScreeningResult: {
        method: 'PUT',
        path: '/literature-reviews/paper-screenings/:paperScreeningId/screening-result',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updatePaperScreeningResultJustification: {
        method: 'POST',
        path: '/literature-reviews/paper-screenings/:paperScreeningId/result-justification',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteLiteratureSearch: {
        method: 'POST',
        path: '/literature-reviews/:id/delete-search',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    exportLiteratureSearches: {
        method: 'POST',
        path: '/literature-reviews/:id/searches/export',
        body: c.noBody(),
        responses: {
            200: c.type(),
        },
    },
    createCriteria: {
        method: 'POST',
        path: '/literature-reviews/criteria',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateCriteria: {
        method: 'PUT',
        path: '/literature-reviews/criteria/:criteriaId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteCriteria: {
        method: 'DELETE',
        path: '/literature-reviews/criteria/:criteriaId',
        responses: {
            200: c.type(),
        },
    },
    generateCriteria: {
        method: 'POST',
        path: '/literature-reviews/:id/generate-criteria',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    upsertFullTextScreening: {
        method: 'POST',
        path: '/literature-reviews/:id/upsert-full-text-screening',
        body: c.noBody(),
        responses: {
            200: c.type(),
        },
    },
    generateFullTextCriteria: {
        method: 'POST',
        path: '/literature-reviews/:id/generate-full-text-criteria',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    executeFullTextScreening: {
        method: 'POST',
        path: '/literature-reviews/:id/execute-full-text-screening',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getFullTextScreening: {
        method: 'GET',
        path: '/literature-reviews/:id/full-text-screening',
        responses: {
            200: c.type(),
        },
    },
    getFullTextScreeningResults: {
        method: 'GET',
        path: '/literature-reviews/:id/full-text-screening/results',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    exportFullTextScreeningResults: {
        method: 'POST',
        path: '/literature-reviews/:id/full-text-screening/results/export',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateFullTextScreeningCriteriaResult: {
        method: 'POST',
        path: '/literature-reviews/full-text-screening/criteria-result',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    uploadWorkPdf: {
        method: 'POST',
        path: '/literature-reviews/paper-screenings/:paperScreeningId/upload-pdf',
        body: c.noBody(), // FormData
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
});
//# sourceMappingURL=literatureReview.js.map